
export const ACCESS_TOKEN = 'access_token'
export const REFRESH_TOKEN = 'refresh_token'
export const BRANDID = 'brandId'
export const userAgent = {
    ANDROID: 'ANDROID',
    IOS:'IOS',
    WECHAT:'WECHAT',
}